import React from 'react';
import BaseV2 from '../../layout/BaseV2';
import SendAnnouncementForm from '../../../components/forms/announcements/sendAnnouncementForm';

/**
 * Envío de anuncios (versión 2): el wrapper `BaseV2` aporta header y sidebar
 * de la versión nueva. La entrada en el sidebar la pinta el módulo
 * `Enviar Anuncios`.
 */
export default function SendAnnouncementV2() {
  return (
    <BaseV2>
      <SendAnnouncementForm />
    </BaseV2>
  );
}
